import * as React from 'react';
import { TextField } from '@material-ui/core';
const defaultOptions = {};
export default (options = defaultOptions) => (props) => {
    return (React.createElement(TextField, { multiline: options.multiline, fullWidth: true, inputProps: {
            maxLength: options.maxLength,
        }, label: props.propertyOptions.displayName, value: props.value || '', onChange: (e) => props.setValue(e.target.value) }));
};
